import React from "react";
import styles from "./node-id-block.module.scss";
import { IconButton } from "@components/atoms/buttons/icon-button/icon-button";

import copyNodeIcon from "../copy-node-icon.svg";
import { ToolTip } from "@src/components/atoms/tooltip/tooltip";

interface NodeIdBlockProps {
  copyFunction: () => void;
  id: string;
  label: string;
  tooltip: string;
  tooltipPosition: "top" | "right" | "bottom" | "left";
  copyTooltip: string;
  copyTooltipPosition: "top" | "right" | "bottom" | "left";
}

export const NodeIdBlock = ({
  copyFunction,
  id,
  label,
  tooltip,
  tooltipPosition,
  copyTooltip,
  copyTooltipPosition,
}: NodeIdBlockProps) => {
  const cssClassName = "node-id-block";

  const shortenDisplayedNodeId = (nodeId: string, num = 36): string => {
    if (nodeId.length <= num) {
      return nodeId;
    }
    return nodeId.substring(0, num) + "...";
  };

  return (
    <div className={styles[cssClassName]}>
      <div className={styles[`${cssClassName}__id-wrapper`]}>
        <div className={styles[`${cssClassName}__id-label-wrapper`]}>
          <div className={styles[`${cssClassName}__id-label-wrapper-label`]}>
            {label}
          </div>

          <div className={styles[`${cssClassName}__id-label-wrapper-button`]}>
            <IconButton
              fun={copyFunction}
              icon={copyNodeIcon}
              tooltip={copyTooltip}
              tooltipPosition={copyTooltipPosition}
            />
          </div>
        </div>

        <div className={styles[`${cssClassName}__id-value-wrapper`]}>
          <ToolTip content={tooltip} position={tooltipPosition}>
            <span>{shortenDisplayedNodeId(id)}</span>
          </ToolTip>
        </div>
      </div>
    </div>
  );
};
